<template>
  <div>
    <Modal :visible="visible" @cancel="handleClose" :size="size">
      <div class="l-container container">
        <div class="box">
          <div class="box-content">
            <div class="menu-content2">
              <SectionContentTitle titleContent="アドレス帳に登録" />
              <div class="content">
                <table class="table-common">
                  <tr class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold label-l">郵便番号</div>
                      <div class="ml-4 category">必須</div>
                    </td>
                    <td class="data">
                      <div class="items-data">
                        <div class="content-data">
                          <div class="mt-3 gap-2" style="display: flex">
                            <a-input
                              :maxLength="3"
                              placeholder=""
                              @keypress="validateNumber($event)"
                              v-model="zipCode1"
                              wovn-ignore
                            />
                            <span
                              style="
                                align-self: center;
                                margin-left: 10px;
                                margin-right: 10px;
                              "
                              >−</span
                            >
                            <a-input
                              :maxLength="4"
                              placeholder=""
                              @keypress="validateNumber($event)"
                              v-model="zipCode2"
                              wovn-ignore
                            />
                            <button
                              @click="loadLocation()"
                              style="margin-left: 30px"
                              class="c-btn-cm btn-white"
                            >
                              住所自動入力
                            </button>
                          </div>
                          <div>※海外在住の方は「000-0000」とご入力ください。</div>
                          <div class="text-primary font-bold">
                            {{ error_message_zipcode }}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!isForeign" class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold label-l">都道府県</div>
                      <div class="ml-4 category">必須</div>
                    </td>
                    <td class="data">
                      <div class="items-data" style="margin-top: 10px">
                        <div class="content-data input-items">
                          <div class="mt-3" wovn-ignore>
                            <a-select
                              class="select-items width-select"
                              v-model="prefectures"
                              placeholder="選択してください "
                              wovn-ignore
                            >
                              <a-select-option v-for="(item, index) in getPrefecturesList" :key="index" :value="item.value" wovn-ignore>{{ item.label }}</a-select-option>
                            </a-select>
                          </div>
                          <div class="text-primary font-bold">
                            {{ error_message_prefectures }}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!isForeign" class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold label-l">市区町村・番地</div>
                      <div class="ml-4 category">必須</div>
                    </td>
                    <td class="data">
                      <div class="items-data" style="margin-top: 10px">
                        <div class="content-data input-items">
                          <div class="mt-3">
                            <a-input
                              :maxLength="100"
                              placeholder=""
                              v-model.trim="cityAddress"
                              wovn-ignore
                            />
                          </div>
                          <div class="text-primary font-bold">
                            {{ error_message_cityAddress }}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!isForeign" class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold label-l">建物・号室<br />(任意)</div>
                    </td>
                    <td class="data">
                      <div class="items-data" style="margin-top: 10px">
                        <div class="content-data input-items">
                          <div class="mt-3">
                            <a-input
                              placeholder=""
                              :maxLength="100"
                              v-model.trim="info_person_form.apartment_number"
                              wovn-ignore
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr></tr>
                </table>
              </div>
              <div class="text-note">
                ※アドレス帳に登録した住所は、申込者情報設定および配送先指定の際に選択可能となります。
              </div>
            </div>
            <div class="buttons flex gap-2 justify-center mt-4 mb-4">
              <button
                class="c-btn btn-white"
                style="margin-right: 20px"
                @click="handleClose"
              >
                <span class="text-moblie">キャンセル</span>
              </button>
              <button class="c-btn btn-grey" @click="handleUpdate">
                <span class="text-moblie">この住所を登録する</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash'
import { SectionContentTitle } from '@/components/compound'
import { UPDATE_INFO_DETAIL } from '@/store/modules/bs_app/actions'
import func_utils from '@/mixins/func_utils'
import { Core as YubinBangoCore } from '@/utils/yubinbango-core2/yubinbango-core'
import { codes } from '@/constants/prefectures'

export default {
  name: 'ZipcodeInfo',
  mixins: [func_utils],
  components: {
    SectionContentTitle
  },
  props: ['visible', 'size', 'prepectureCode', 'addressMember'],
  data() {
    return {
      customerPlan: null,
      email: 0,
      phone: 0,
      myEmail: '',
      myPhone: 0,
      firstEmail: '',
      secondEmail: '',
      firstTel: '',
      secondTel: '',
      zipCode1: '',
      zipCode2: '',
      prefectures: undefined,
      cityAddress: null,
      apartment_number: '',
      titleContent: ['お申し込み内容', '申込者情報の変更'],
      error_message: 'メールアドレスを入力してください',
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      error_message_email: null,
      error_message_phone: null,
      error_message_zipcode: null,
      error_message_prefectures: null,
      error_message_cityAddress: null,
      hasError: false,
      info_person_form: {
        memberId: '',
        firstName: '',
        familyName: '',
        apartment_number: '',
        email: '',
        secondEmail: null,
        tel: '',
        secondTel: null
      },
      profileInfo: {},
      totalAdultPeople: 0,
      totalChildren: 0,
      zipcodeError: false,
      isForeign: false,
      popupZipcodeInfo: false,
      regionId: null
    }
  },
  mounted() {
    this.customerPlan = this.customerPlanState
  },
  computed: {
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.getters, 'planDetail', null))
    },
    customerPlanState() {
      return _.cloneDeep(_.get(this.$store.getters, 'customerPlan', null))
    },
    getInfoDetail() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.info_detail', null))
    },
    getDataBsApp02001() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.bs_app_02_001', null))
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    getPrefecturesList() {
      const list = []
      const prefecturesList = Object.entries(codes)
      prefecturesList.forEach((item) => {
        list.push({ label: item[1].name, value: item[1].name })
      })
      return list
    }
  },
  watch: {
    visible() {
      this.mountData(this.prepectureCode)
    }
  },
  methods: {
    mountData(zipCode) {
      if (zipCode) {
        const postalCode = zipCode.postalCode
        const cityAddress = zipCode.address1
        new YubinBangoCore(postalCode, (data) => {
          if (data !== null) {
            this.zipCode1 = postalCode.substring(0, 3)
            this.zipCode2 = postalCode.substring(3, 7)
            this.prefectures = data.region ? data.region : ''
            this.cityAddress = cityAddress
              ? cityAddress.replace(this.prefectures, '')
              : ''
            this.info_person_form.apartment_number = zipCode.address2
            this.regionId = _.get(data, 'region_id', '')
          }
        })
        this.checkiIsForeign()
      } else {
        this.zipCode1 = ''
        this.zipCode2 = ''
        this.prefectures = undefined
        this.cityAddress = ''
        this.info_person_form.apartment_number = ''
      }
      this.error_message_zipcode = ''
      this.error_message_prefectures = ''
      this.error_message_cityAddress = ''
    },
    checkiIsForeign() {
      if (this.zipCode1 && this.zipCode2) {
        if (this.zipCode1 === '000' && this.zipCode2 === '0000') {
          this.isForeign = true
          this.hasError = false
          this.prefectures = ''
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
        } else {
          this.isForeign = false
        }
      }
    },
    getProfileInfo() {
      if (this.getInfoDetail === null) {
        const bs_app_02_001 = this.getDataBsApp02001
        this.profileInfo = bs_app_02_001?.profileInfo
        if (this.profileInfo) {
          const postalCode = _.get(this.profileInfo, 'addresses[0].postalCode', '')
          this.info_person_form.memberId = _.get(this.userInfo, 'ssoCustomerNo', null)
          this.info_person_form.firstName = this.profileInfo.firstName
          this.info_person_form.familyName = this.profileInfo.familyName
          this.info_person_form.firstNameKana = this.profileInfo.firstNameKana
          this.info_person_form.familyNameKana = this.profileInfo.familyNameKana
          this.info_person_form.email = this.profileInfo.email
          this.info_person_form.secondEmail = this.profileInfo.secondEmail
          this.info_person_form.tel = this.profileInfo.tel
          this.info_person_form.secondTel = this.profileInfo.secondTel
          this.isForeign = this.profileInfo.isForeign
          if (postalCode) {
            this.cityAddress = _.get(this.profileInfo, 'addresses[0].address1', '')
            this.info_person_form.apartment_number = _.get(
              this.profileInfo,
              'addresses[0].address2',
              ''
            )
            this.zipCode1 = postalCode.substring(0, 3)
            this.zipCode2 = postalCode.substring(3, 7)
            this.getProfileMe()
          }
          this.checkiIsForeign()
        }
      }
    },
    checkValidateInput() {
      let hasError = false
      if (!this.zipCode1 || !this.zipCode2) {
        hasError = true
        this.error_message_zipcode = '郵便番号を入力してください'
      } else if (this.zipCode1.length < 3 || this.zipCode2.length < 4) {
        hasError = true
        this.error_message_zipcode = '郵便番号の形式が正しくありません。'
      } else {
        this.error_message_zipcode = ''
      }
      if (this.zipCode1 !== '000' || this.zipCode2 !== '0000') {
        this.isForeign = false
        if (!this.prefectures) {
          hasError = true
          this.error_message_prefectures = '都道府県を入力してください'
        } else {
          this.error_message_prefectures = ''
        }
        if (!this.cityAddress) {
          hasError = true
          this.error_message_cityAddress = '市区町村・番地を入力してください'
        } else {
          this.error_message_cityAddress = ''
        }
      }
      return hasError
    },
    async handleUpdate() {
      const errorInput = this.checkValidateInput()
      if (!errorInput) {
        let newMemberAddress = this.addressMember
        const index = this.prepectureCode?.index
        const data = {
          postalCode: this.zipCode1 + this.zipCode2,
          prefectureCode: this.regionId ? this.regionId : 1,
          address1: this.prefectures + this.cityAddress,
          address2: this.info_person_form.apartment_number
            ? this.info_person_form.apartment_number
            : ''
        }
        if (index >= 0) {
          newMemberAddress.splice(index, 1, data)
        } else {
          newMemberAddress = [...newMemberAddress, ...[data]]
        }
        const address = newMemberAddress
        const addressMember = {
          addresses: address,
          defaultDestination: 0
        }
        console.log('----------->addressMember:', addressMember)
        await this.$repositories('user').updateUserAddress(addressMember)
        this.handleClose()
      }
    },
    getProfileMe() {
      const zipCode = `${this.zipCode1}${this.zipCode2}`
      if (this.zipCode1 && this.zipCode2) {
        new YubinBangoCore(zipCode, (data) => {
          if (data !== null) {
            this.prefectures = data.region ? data.region : undefined
          }
        })
      }
    },
    validateZipcodeInput() {
      this.zipCode1 = this.inputAge(this.zipCode1)
      this.zipCode2 = this.inputAge(this.zipCode2)
    },
    async loadLocation() {
      this.validateZipcodeInput()
      this.isForeign = false
      if (this.zipCode1 && this.zipCode2) {
        if (this.zipCode1 === '000' && this.zipCode2 === '0000') {
          this.isForeign = true
          this.hasError = false
          this.prefectures = ''
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
          this.error_message_zipcode = ''
          return
        }
        if (this.zipCode1.length < 3 || this.zipCode2.length < 4) {
          this.zipcodeError = true
          this.hasError = true
          this.prefectures = undefined
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
          this.error_message_zipcode = '郵便番号の形式が正しくありません。'
        }
        const zipCode = `${this.zipCode1}${this.zipCode2}`
        if (zipCode.length > 6) {
          new YubinBangoCore(zipCode, (data) => {
            if (data !== null) {
              if (data.region_id) {
                this.zipcodeError = false
                this.error_message_zipcode = ''
              } else {
                this.zipcodeError = true
                this.hasError = true
                if (zipCode.length > 6) {
                  this.error_message_zipcode =
                    '郵便番号が存在しません。有効な郵便番号を入力してください'
                }
              }
              this.prefectures = data.region ? data.region : undefined
              const cityName = _.get(data, 'locality', '')
              const townName = _.get(data, 'street', '')
              this.cityAddress = [cityName, townName].filter((val) => val).join('')
              this.info_person_form.apartment_number = ''
              this.regionId = _.get(data, 'region_id', '')
            }
            this.checkMessageError()
          })
        } else {
          this.checkMessageError()
        }
      } else {
        this.zipcodeError = false
        this.checkMessageError()
        this.prefectures = undefined
        this.cityAddress = ''
      }
    },
    checkMessageError() {
      this.hasError = false
      if (!this.prefectures) {
        this.hasError = true
        this.error_message_prefectures = '都道府県を入力してください'
      } else {
        this.error_message_prefectures = ''
      }
      if (!this.cityAddress || this.cityAddress.trim() === '') {
        this.hasError = true
        this.error_message_cityAddress = '市区町村・番地を入力してください'
      } else {
        this.error_message_cityAddress = ''
      }
      if (!this.zipcodeError) {
        if (this.zipCode1 === '' || this.zipCode2 === '') {
          this.hasError = true
          this.error_message_zipcode = '郵便番号を入力してください'
        } else {
          this.error_message_zipcode = ''
        }
      }
    },
    updateInfoDetail() {
      const info = {
        memberId: this.info_person_form.memberId,
        firstName: _.get(this.info_person_form, 'firstName', ''),
        familyName: _.get(this.info_person_form, 'familyName', ''),
        zipCode1: this.zipCode1,
        zipCode2: this.zipCode2,
        prefectures: this.prefectures,
        cityAddress: this.cityAddress ? this.cityAddress.trim() : this.cityAddress,
        apartment_number: _.get(this.info_person_form, 'apartment_number', ''),
        info_person: this.info_person,
        email: this.info_person_form.email,
        secondEmail: this.info_person_form.secondEmail,
        tel: this.info_person_form.tel,
        secondTel: this.info_person_form.secondTel,
        myEmail: this.myEmail,
        myPhone: this.myPhone,
        isForeign: this.isForeign
      }
      this.$store.dispatch(UPDATE_INFO_DETAIL, info).then(() => {})
    },
    async handleNext() {
      await this.loadLocation()
      this.updateInfoDetail()
      // eslint-disable-next-line no-empty
      if (!this.hasError) {
      }
    },
    handleClose() {
      this.$emit('openAddress')
      this.$emit('cancel')
    },
    cancelPopupInfo() {
      this.popupZipcodeInfo = false
    },
    handlePopupInfo() {
      this.popupZipcodeInfo = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
